module.exports = __webpack_public_path__ + "static/pie_painter_9-a87f5768071711dbf6dda0e90774664c.png";